export class PharmacyStoreSearchRequestModel {
    public PharmacyId?: String;
    public NCPDPID?: String;
    public PageNumber!:number
    public PageSize!:number
}

export class PharmacyStoreSearchResponseModel {
    public NCPDPID: String;
    public NPI: String;
    public PharmacyName: String;
    public PID:String;    
    public Status: String;
    public UpdatedBy: String;
    public UpdatedDate: String;
    public RecordActiveDate: String;
    public RecordDeactiveDate: String;
}

export class Pagination{
  public PageNumber!:number;
  public PageSize!:number;
  public TotalItems!:number;
  public TotalPages!:number;
}

export class PharmacyStoreSearchGridData{
    public TotalNumberOfRecords :number;
    public pharmacyStoreSearchData :PharmacyStoreSearchResponseModel[];
    public pagination: Pagination = new Pagination;
  }
  
  export class PharmacyStoreSearchGridDataMapper{
    mapToModel(json: any): PharmacyStoreSearchGridData {
      let pharmacyStoreSearchGridData: PharmacyStoreSearchGridData = null;

      if (json) {
        pharmacyStoreSearchGridData = new PharmacyStoreSearchGridData();
        pharmacyStoreSearchGridData.pharmacyStoreSearchData = json.ResponseData.Items;

        if(json.ResponseData.Pagination!=null)
        {
          pharmacyStoreSearchGridData.pagination.PageNumber=json.ResponseData.Pagination.PageNumber;
          pharmacyStoreSearchGridData.pagination.PageSize=json.ResponseData.Pagination.PageSize;
          pharmacyStoreSearchGridData.pagination.TotalItems=json.ResponseData.Pagination.TotalItems;
          pharmacyStoreSearchGridData.pagination.TotalPages=json.ResponseData.Pagination.TotalPages;
        }
      }
      return pharmacyStoreSearchGridData;
    }
  }
